export default "__VITE_ASSET__Czh$C$tr__"